import { Directive, computed, inject, input } from '@angular/core';
import { PulseSegmentedToggleComponent } from './pulse-segmented-toggle.component';

@Directive({
    // Only valid on <button> elements to enforce correct semantics
    selector: 'button[pulseSegmentedToggleItem]',
    host: {
        class: 'pulse-segmented-toggle__item',
        '[class.pulse-segmented-toggle__item--active]': 'isActive()',
        '[attr.aria-pressed]': 'isActive()',
        type: 'button',
        '(click)': 'toggle.select(value())',
    },
})
export class PulseSegmentedToggleItemDirective {
    protected readonly toggle = inject(PulseSegmentedToggleComponent);
    readonly value = input.required<string>();
    readonly isActive = computed(() => this.toggle.value() === this.value());
}
